import { LOCAL_ACCOUNTS_URL } from "./const";
import { isEmpty } from "lodash";

export function getAccountsUrlValue() {
  const REACT_ENV = process.env.NODE_ENV;
  const ACCOUNTS_URL = !!process.env.REACT_APP_ACCOUNTS_URL && process.env.REACT_APP_ACCOUNTS_URL !== "" ? process.env.REACT_APP_ACCOUNTS_URL : LOCAL_ACCOUNTS_URL;
  if (!isEmpty(REACT_ENV)) {
    return ACCOUNTS_URL;
  } else {
    return LOCAL_ACCOUNTS_URL;
  }
}

export const getAccountsUrl = () => {
  return getAccountsUrlValue();
};
